import React, { FC } from "react";
import styled from "styled-components";

const data = [
  {
    code: "SUPER",
    src: "/static/icons/good.png",
    src2x: "/static/icons/good_2x.png",
  },
  {
    code: "POOR",
    src: "/static/icons/suggest.png",
    src2x: "/static/icons/suggest_2x.png",
  },
  {
    code: "BAD",
    src: "/static/icons/bad.png",
    src2x: "/static/icons/bad_2x.png",
  },
];

const Icon: FC<{
  size?: number;
  code: string;
}> = ({ code, size, ...props }) => {
  const icon = data.find((el) => el.code === code);

  return (
    <IconEl
      src={icon.src}
      srcSet={`${icon.src2x} 2x`}
      width={size ? `${size}px` : undefined}
      height={size ? `${size}px` : undefined}
      alt=""
      {...props}
    />
  );
};

interface IconElProps {
  size?: number;
}
const IconEl = styled.img<IconElProps>`
  display: inline-block;
  width: ${({ size }) => (size ? `${size}px` : undefined)};
  height: ${({ size }) => (size ? `${size}px` : undefined)};
`;

export default Icon;
